import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

export const Content = styled.div`
  background: white;
  width: 100%;
  max-width: 600px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 0.3s ease-out;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
`;

export const Header = styled.div`
  background: #111827;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  h2 {
    color: #ffd700;
    margin: 0;
    font-size: 20px;
    font-weight: 700;
  }
  button {
    background: transparent;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
  }
`;

export const Body = styled.div`
  padding: 30px;
  overflow-y: auto;
  flex-grow: 1;
  .search-box {
    position: relative;
    margin-bottom: 20px;
    input {
      width: 100%;
      padding: 12px 15px 12px 45px;
      border: 2px solid #e5e7eb;
      border-radius: 10px;
      font-size: 16px;
      outline: none;
      box-sizing: border-box;
      &:focus {
        border-color: #d4af37;
      }
    }
    svg {
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
      color: #9ca3af;
    }
  }
  .section-label {
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 10px;
    display: block;
  }
  .empty-msg {
    text-align: center;
    color: #9ca3af;
    padding: 20px;
  }
`;

export const OptionCard = styled.div`
  flex: 1;
  padding: 15px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border: 2px solid ${(props) => (props.active ? "#D4AF37" : "#f3f4f6")};
  background: ${(props) => (props.active ? "#fffbf0" : "white")};
  strong {
    color: ${(props) => (props.active ? "#D4AF37" : "#111827")};
    font-size: 13px;
    margin-bottom: 4px;
  }
  span {
    font-size: 11px;
    color: #6b7280;
    font-weight: 600;
  }
  &:hover {
    border-color: #d4af37;
    transform: translateY(-2px);
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  color: #d4af37;
  .spinner {
    font-size: 30px;
    animation: ${spin} 1s linear infinite;
  }
`;

export const ContractList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ContractOption = styled.div`
  border: 2px solid ${(props) => (props.selected ? "#D4AF37" : "#f3f4f6")};
  background: ${(props) => (props.selected ? "#fffbf0" : "white")};
  padding: 15px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .info {
    h4 {
      margin: 0 0 5px 0;
      color: #111827;
    }
    p {
      margin: 0;
      font-size: 12px;
      color: #6b7280;
    }
  }
  .value {
    font-weight: 700;
    color: #111827;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
  button {
    background: #f3f4f6;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    cursor: pointer;
  }
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SimulationBox = styled.div`
  background: linear-gradient(135deg, #fef9c3, #fffbeb);
  border: 1px solid #fde047;
  border-radius: 12px;
  padding: 15px;
  color: #854d0e;
  .value-row {
    display: flex;
    justify-content: space-between;
    background: rgba(255, 255, 255, 0.6);
    padding: 10px;
    border-radius: 8px;
    strong {
      color: #15803d;
    }
  }
`;

export const TermsScrollBox = styled.div`
  height: 150px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  padding: 15px;
  border-radius: 8px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  input {
    width: 18px;
    height: 18px;
    accent-color: #d4af37;
  }
`;

export const Footer = styled.div`
  padding: 20px 30px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
`;

export const ActionButton = styled.button`
  background: linear-gradient(135deg, #d4af37, #b88a00);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  &:disabled {
    background: #e5e7eb;
    color: #9ca3af;
    cursor: not-allowed;
  }
`;

export const BackButton = styled.button`
  background: white;
  border: 1px solid #d1d5db;
  color: #374151;
  padding: 12px 20px;
  border-radius: 12px;
  cursor: pointer;
`;

const slideDown = keyframes`
  from { transform: translate(-50%, -20px); opacity: 0; }
  to { transform: translate(-50%, 0); opacity: 1; }
`;

export const ToastContainer = styled.div`
  position: fixed;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  padding: 16px 20px;
  border-radius: 12px;
  background: ${(props) => (props.type === "error" ? "#FFF5F5" : "#F0FFF4")};
  border: 1px solid
    ${(props) => (props.type === "error" ? "#FEB2B2" : "#9AE6B4")};
  animation: ${slideDown} 0.4s ease;
`;
